import { Component, Input, OnInit, Optional, Self } from '@angular/core'
import { NgControl, ReactiveFormsModule } from '@angular/forms'
import { Observable } from 'rxjs'
import { GendersService } from '../../../../services/domain/codelists/genders.service'
import { Gender } from '../../../../models/gender'
import { AsyncPipe, NgForOf, NgIf } from '@angular/common'
import { IonicModule } from '@ionic/angular'
import { ControlValueAccessorWrapperComponent } from '../../../../shared/helpers/control-value-accessor-wrapper/control-value-accessor-wrapper.component'

@Component({
  selector: 'app-gender-select',
  templateUrl: './gender-select.component.html',
  styleUrls: ['./gender-select.component.scss'],
  imports: [ReactiveFormsModule, AsyncPipe, IonicModule, NgIf, NgForOf],
})
export class GenderSelectComponent extends ControlValueAccessorWrapperComponent implements OnInit {
  @Input() label: string

  genders$: Observable<Gender[]> = this.gendersService.getAllWithAddedEmptyGender()

  constructor(
    @Optional() @Self() public ngControl: NgControl,
    private gendersService: GendersService,
  ) {
    super(ngControl)
  }

  registerOnChange(fn: (_: any) => void): void {}

  registerOnTouched(fn: any): void {}

  writeValue(obj: any): void {}
}
